module.exports = __webpack_public_path__ + "assets/img/5-5.cbb47e62.png";